function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { useTheme } from 'styled-components';
var BirminghamMidshiresIcon = function BirminghamMidshiresIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0002 0.585785L23.4144 2L13.4139 11.9998L23.4144 22L22.0002 23.4142L11.9999 13.4138L2.00015 23.4142L0.585938 22L10.5859 11.9998L0.585938 2L2.00015 0.585785L11.9999 10.5858L22.0002 0.585785Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
BirminghamMidshiresIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var BlackHorseIcon = function BlackHorseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M24 22.5882L22.5882 24L12 13.4118L1.41176 24L4.24341e-05 22.5882L10.5882 12L-9.87362e-07 1.41179L1.41176 3.04558e-05L12 10.5883L22.5882 -2.89471e-06L24 1.41176L13.4118 12L24 22.5882Z",
    fill: "currentColor"
  }));
};
BlackHorseIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var BosIcon = function BosIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.247849 23.7522C0.413081 23.9174 0.619621 24 0.846816 24C1.07401 24 1.28055 23.9174 1.44578 23.7522L12 13.1979L22.5542 23.7522C22.7194 23.9174 22.926 24 23.1532 24C23.3597 24 23.5869 23.9174 23.7522 23.7522C24.0826 23.4217 24.0826 22.8847 23.7522 22.5542L13.1979 12L23.7522 1.44578C24.0826 1.11532 24.0826 0.578313 23.7522 0.247849C23.4217 -0.0826162 22.8847 -0.0826162 22.5542 0.247849L12 10.8021L1.44578 0.247849C1.11532 -0.0826162 0.578313 -0.0826162 0.247849 0.247849C-0.0826162 0.578313 -0.0826162 1.11532 0.247849 1.44578L10.8021 12L0.247849 22.5542C-0.0826162 22.8847 -0.0826162 23.4217 0.247849 23.7522Z",
    fill: "currentColor"
  }));
};
BosIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var HalifaxIcon = function HalifaxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0002 0.585785L23.4144 2L13.4139 11.9998L23.4144 22L22.0002 23.4142L11.9999 13.4138L2.00015 23.4142L0.585938 22L10.5859 11.9998L0.585938 2L2.00015 0.585785L11.9999 10.5858L22.0002 0.585785Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
HalifaxIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var LloydsReimaginedIcon = function LloydsReimaginedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14.1992 12.0019L22.5091 3.67858C23.1217 3.06495 23.1217 2.07385 22.5091 1.46022C21.8965 0.846593 20.9068 0.846593 20.2942 1.46022L11.9843 9.78339L3.6744 1.46022C3.06176 0.846593 2.07212 0.846593 1.45948 1.46022C0.84684 2.07385 0.84684 3.06495 1.45948 3.67858L9.76937 12.0019L1.45948 20.3253C0.84684 20.9389 0.84684 21.93 1.45948 22.5437C1.77365 22.8583 2.16637 23 2.57479 23C2.98322 23 3.37594 22.8426 3.69011 22.5437L11.9838 14.2205L20.3099 22.5437C20.6241 22.8583 21.0168 23 21.4252 23C21.8336 23 22.2263 22.8426 22.5405 22.5437C23.1532 21.93 23.1532 20.9389 22.5405 20.3253L14.1992 12.0019Z",
    fill: "currentColor"
  }));
};
LloydsReimaginedIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var Lloyds2023Icon = function Lloyds2023Icon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.247849 23.7522C0.413081 23.9174 0.619621 24 0.846816 24C1.07401 24 1.28055 23.9174 1.44578 23.7522L12 13.1979L22.5542 23.7522C22.7194 23.9174 22.926 24 23.1532 24C23.3597 24 23.5869 23.9174 23.7522 23.7522C24.0826 23.4217 24.0826 22.8847 23.7522 22.5542L13.1979 12L23.7522 1.44578C24.0826 1.11532 24.0826 0.578313 23.7522 0.247849C23.4217 -0.0826162 22.8847 -0.0826162 22.5542 0.247849L12 10.8021L1.44578 0.247849C1.11532 -0.0826162 0.578313 -0.0826162 0.247849 0.247849C-0.0826162 0.578313 -0.0826162 1.11532 0.247849 1.44578L10.8021 12L0.247849 22.5542C-0.0826162 22.8847 -0.0826162 23.4217 0.247849 23.7522Z",
    fill: "currentColor"
  }));
};
Lloyds2023Icon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MbnaIcon = function MbnaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0025 9.54896L20.9855 0.51359C21.6703 -0.173464 22.781 -0.173464 23.476 0.527297C24.1676 1.22292 24.1608 2.35544 23.4879 3.03222L14.5687 12.0033L23.4879 20.9744C24.1727 21.6632 24.1727 22.7803 23.476 23.4794C22.7844 24.175 21.6584 24.1681 20.9855 23.4913L11.9975 14.451L3.01446 23.4864C2.32967 24.1735 1.21903 24.1735 0.52403 23.4727C-0.167566 22.7771 -0.160752 21.6446 0.512106 20.9678L9.43131 11.9967L0.512106 3.02557C-0.172676 2.3368 -0.172676 1.21969 0.52403 0.520647C1.21563 -0.174974 2.3416 -0.168121 3.01446 0.508653L12.0025 9.54896Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "24",
    height: "24",
    fill: "white"
  }))));
};
MbnaIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ScottishWidowsIcon = function ScottishWidowsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.247849 23.7522C0.413081 23.9174 0.619621 24 0.846816 24C1.07401 24 1.28055 23.9174 1.44578 23.7522L12 13.1979L22.5542 23.7522C22.7194 23.9174 22.926 24 23.1532 24C23.3597 24 23.5869 23.9174 23.7522 23.7522C24.0826 23.4217 24.0826 22.8847 23.7522 22.5542L13.1979 12L23.7522 1.44578C24.0826 1.11532 24.0826 0.578313 23.7522 0.247849C23.4217 -0.0826162 22.8847 -0.0826162 22.5542 0.247849L12 10.8021L1.44578 0.247849C1.11532 -0.0826162 0.578313 -0.0826162 0.247849 0.247849C-0.0826162 0.578313 -0.0826162 1.11532 0.247849 1.44578L10.8021 12L0.247849 22.5542C-0.0826162 22.8847 -0.0826162 23.4217 0.247849 23.7522Z",
    fill: "currentColor"
  }));
};
ScottishWidowsIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import { useBrand } from "../BrandProvider";
import SvgIcon from "../SvgIcon";
import { LLOYDS, BIRMINGHAM_MIDSHIRES, BLACK_HORSE, WHITE_LABEL_DARK, WHITE_LABEL_LIGHT, BOS, HALIFAX, LLOYDS2023, MBNA, SCOTTISH_WIDOWS } from "../../constants";
export default function Cross(_ref) {
  var _theme$assets, _theme$assets$icons;
  var rest = _extends({}, _ref);
  var _ref2 = useBrand() || {},
    _ref2$brand = _ref2.brand,
    brand = _ref2$brand === void 0 ? LLOYDS : _ref2$brand;
  var theme = useTheme();
  var svg;
  if ((_theme$assets = theme.assets) !== null && _theme$assets !== void 0 && (_theme$assets$icons = _theme$assets.icons) !== null && _theme$assets$icons !== void 0 && _theme$assets$icons.cross) {
    svg = theme.assets.icons.cross;
  } else {
    switch (brand) {
      case BIRMINGHAM_MIDSHIRES:
        svg = BirminghamMidshiresIcon;
        break;
      case BLACK_HORSE:
      case WHITE_LABEL_DARK:
      case WHITE_LABEL_LIGHT:
        svg = BlackHorseIcon;
        break;
      case BOS:
        svg = BosIcon;
        break;
      case HALIFAX:
        svg = HalifaxIcon;
        break;
      case LLOYDS:
        svg = LloydsReimaginedIcon;
        break;
      case LLOYDS2023:
        svg = Lloyds2023Icon;
        break;
      case MBNA:
        svg = MbnaIcon;
        break;
      case SCOTTISH_WIDOWS:
        svg = ScottishWidowsIcon;
        break;
      default:
        console.warn("Icon \"Cross\" is not available for brand ".concat(brand));
        svg = function svg() {
          return null;
        };
    }
  }
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    svg: svg
  }, rest));
}